import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  pdf,
} from '@react-pdf/renderer';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Html from 'react-pdf-html';
import { config } from 'src/config';
import { useAppSelector } from 'src/rtk/app/hook';

interface Props {
  userInfo: any;
  setReportId: any;
  reportId: any;
  controllerInfo: any
}
// Create styles
const styles = StyleSheet.create({
  page: {
    margin: 20,
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0,
  },
  nextLine: {
    marginTop: -20,
    textAlign: 'center',
    fontSize: '15px',
  },
});

export const NotificationPdf = (props: Props) => {
  const { userInfo, setReportId, reportId, controllerInfo } = props;
  const [imageBase64, setImageBase64] = useState('');

  const token = useAppSelector((state) => state.auth.token);


  const fetchImageBase64 = async (filepath: string) => {
    const res = await fetch(`${config.API_URL}/v1/get-image?filepath=${filepath}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`, // if needed
        'Accept': 'image/*',                    // optional
      },
    });

    const blob = await res.blob();
    const reader = new FileReader();

    return await new Promise<string>((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };


  useEffect(() => {
    if (controllerInfo?.controller_signature) {
      fetchImageBase64(controllerInfo?.controller_signature.replace(/^storage\//, "")).then((base64) => {
        setImageBase64(base64);
      });
    }
  }, [controllerInfo?.controller_signature]);

  const html = `  
  <html>    
    <body>
        <style>        

        .print-container{
          padding: 0px 30px;
        }

        .wide-column {
          width: 500px;
          background-color: powderblue;
        }

        table {
          margin: 0px 0px;
          padding: 0px;
          border: 1px solid black;
          font-size: 12px;
        }

        table > tbody> tr > *{
          padding: 5px
        }

        table th {
          text-align: center;    
        }
        
        table td {
                
        }

        .bgColor {
          background-color: powderblue;
        }
        b {
          font-family: 'Times-Bold'; 
        }
        p {
          font-size: 14px
        }

        span {
          font-size: 14px;
        }

        .tableMargin {
          margin-top: 5px;
          margin-bottom: 5px;
        }
       
        .signature-box {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: 50px;
        }
      </style>

      <div class="print-container"> 
        <div style="margin-top: 30px; margin-bottom: 10px;">
          <span> Date: ${moment(new Date()).format('DD-MMMM-YYYY')} </span>
        </div>
        <div style="text-align: center; margin-top: 10px; margin-bottom: 20px;">
          <b> FCPS Examination, ${controllerInfo?.thesis_title?.session_name === 'January-June' ? 'January' : 'July'} ${controllerInfo?.thesis_title?.session_year} </b>
        </div>
        <div style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
            <b> NOTIFICATION </b>
        </div>
        <p>
         The following candidate has been declared passed in Thesis Defense Examination.
        </p>
        <table class="tableMargin">
          <thead>
            <tr>
                <th>BMDC No.</th>
                <th>Name</th>
                <th>Subject</th>
            </tr>
          </thead>
          <tbody>
            <tr>
                <td style="text-align: center;">${userInfo?.data?.details?.bmdc_registration_no || ''}</td>
                <td style="text-align: center;">${userInfo?.data?.details?.personal_info?.full_name || ''}</td>                
                <td style="text-align: center;">${userInfo?.data?.details?.subject?.subject_name || ''}</td>                
            </tr>

            
          </tbody>
        </table>
        
          
          
        <div class="signature-box">
            <img src="${imageBase64}" style="width: 120px; height: 30px; margin-bottom: 0px;" />
            <div style="font-size: 14px; font-weight: bold">${controllerInfo?.controller_name}</div>
            <span>Controller of Examination, BCPS</span>
        </div>
      </div>      
    </body>
  </html>
`;


  const MyDocument = (
    <Document>
      <Page size="A4">
        <View style={styles.row} wrap={true}>
          <Image
            src="/images/apple-icon-180x180.png"
            style={{
              width: '40px',
              marginTop: '20px',
              marginBottom: '0px',
              marginLeft: '40px',
            }}
          />
          <Text
            style={{
              textAlign: 'center',
              fontFamily: 'Times-Bold',
              fontSize: '14px',
              marginTop: '20px',
              marginBottom: '0px',
              marginLeft: '10px',
            }}
          >
            BANGLADESH COLLEGE OF PHYSICIANS AND SURGEONS (BCPS)
          </Text>
        </View>
        <Text style={styles.nextLine}>
          Examinations Department
        </Text>

        <Html>{html}</Html>
      </Page>
    </Document>
  );

  useEffect(() => {
    if (reportId && imageBase64) {
      const pdfData = pdf(MyDocument).toBlob();
      pdfData.then((pdfData) => {
        const pdfContent = new Blob([pdfData], { type: 'application/pdf' });
        const url = URL.createObjectURL(pdfContent);
        setReportId('');
        window.open(url, '_blank');
      });
    }
  }, [reportId, imageBase64]);

  return (
    <div>

    </div>
  );
};
